import GameItem from "component/game/GameItem";
import GameItemBanner from "component/game/GameItemBanner";

export { GameItem };
export { GameItemBanner };

export default Object.assign({
  GameItem,
  GameItemBanner,
});
